import { render, staticRenderFns } from "./EditStickie.vue?vue&type=template&id=6b8c8997&scoped=true&"
import script from "./EditStickie.vue?vue&type=script&lang=js&"
export * from "./EditStickie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8c8997",
  null
  
)

export default component.exports